/**
 * A Netx.Menu defines menus, composed of actions, for use with the data-action-context tag in our templates.
 * It is a more flexible & more centralized syntax than our previous system.  Menus are also use to define
 * tabsets and other navigational structures.
 *
 * The 'actions' property of a Netx.Menu is an array that can contain either the names of actions
 * (defined in Netx.Actions) or arrays of same.  The arrays are used to define sections in situations
 * where that is useful.
 *
 * The action entries match the "event" property of defined actions.
 *
 * This object is not parsed until the moment a menu is rendered.  Nonexistent actions are ignored.
 * @class
 */
import Base from './netx-model';
import {FindLegacyAction} from '@netx/core/legacyActionManager';

class Menu extends Base {
	/** @type {object} */
	get defaults() {
		return {
			label: '', // in some situations (such as submenus) a menu may need a label
			actions: [], // actions in the menu; see example below.
		};
	}

	/** @type {boolean} */
	get isMenu() {
		return this.constructor.__isMenu__;
	}

	/*
	 * return the names of all the actions in a menu, i.e. flatten the menu
	 */
	flatten() {
		return this.get('actions'); // TODO: flatten
	}

	/*
	 * return a flat list of all the action objects (that exist) referenced by a menu
	 */
	toActions() {
		var actions = [];
		_.each(this.flatten(), function (actionName) {
			if (actionName.isMenu) {
				actions = actions.concat(actionName.toActions());
			} else if (_.isArray(actionName)) {
				_.map(actionName, function (name) {
					var action = FindLegacyAction(actionName);
					action && actions.push(action);
				});
			} else if (_.isString(actionName)) {
				var action = FindLegacyAction(actionName);
				action && actions.push(action);
			} else {
				console.warn('undefined action ' + actionName);
			}
		});
		return actions;
	}

	/** @type {boolean} */
	static get __isMenu__() {
		return true;
	}

	/** @type {string} */
	static get __name__() {
		return 'Menu';
	}
}

export default Menu;
